module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsChristmas@2x.513c24d.jpg";